// extracted by mini-css-extract-plugin
export var inputGroupSm = "styles-module--input-group-sm--36OPt";
export var inputGroupLg = "styles-module--input-group-lg--3bw0i";
export var expand = "styles-module--expand--3Rklq";
export var superCard = "styles-module--super-card--3MUAE";